import { Button } from 'react-bootstrap'
import { Plus } from 'lucide-react'

export default function AddButton(props) {

    const { button_name, onClick } = props

    return (
        <>
            <Button type='button' variant="primary" size='sm' className='d-flex align-items-center create_btn' onClick={onClick}><Plus size={18} className='' />{button_name}</Button>
        </>
    )
}
